import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the worn brake icon
 * 
 * @param {Object} props - The props of the component
 * @returns The worn brake icon
 */
const WornBrakeIcon = (props) => (
  <Icon viewBox="0 0 20.42 15" {...props}>
    <defs>
      <clipPath id="clip-path">
        <rect width="20.42" height="15" fill="currentColor" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip-path)">
      <path
        d="M27.887,18.41a6.733,6.733,0,1,1,6.734-6.733,6.741,6.741,0,0,1-6.734,6.733m0-12.351a5.618,5.618,0,1,0,5.618,5.618A5.624,5.624,0,0,0,27.887,6.06"
        transform="translate(-17.677 -4.131)"
        fill="currentColor"
      />
      <path
        d="M17.082,0,15.864,1.3a8.416,8.416,0,0,1,.1,12.4L17.176,15a10.192,10.192,0,0,0-.094-15M4.556,1.3,3.338,0a10.192,10.192,0,0,0-.094,15L4.46,13.7a8.416,8.416,0,0,1,.1-12.4"
        transform="translate(0 0)"
        fill="currentColor"
      />
      <path
        d="M58.215,28.3h-1.3a.247.247,0,0,1-.247-.247V22.634a.247.247,0,0,1,.247-.247h1.3a.247.247,0,0,1,.247.247v5.422a.247.247,0,0,1-.247.247"
        transform="translate(-47.356 -18.708)"
        fill="currentColor"
      />
      <path
        d="M58.215,64.421h-1.3a.247.247,0,0,1-.247-.247v-.843a.247.247,0,0,1,.247-.247h1.3a.247.247,0,0,1,.247.247v.843a.247.247,0,0,1-.247.247"
        transform="translate(-47.356 -52.717)"
        fill="currentColor"
      />
    </g>
  </Icon>
);

export default React.memo(WornBrakeIcon);
